import { telephoneMask, postcodeMask, sortCodeMask } from 'shared/Inputs/inputMasks';
import { CurrencySymbol } from 'shared/interface/globalInterface';
import { TextFormatter } from './interface';
import { Nullable } from '../types';

export const formatText = (text: string): TextFormatter => {
  const actions: any = {};
  let formattedText = text;

  const formatNumber = () => {
    formattedText = formattedText ? parseFloat(formattedText).toLocaleString('en') : formattedText;

    return actions;
  };

  actions.toUpperCase = () => {
    formattedText = formattedText.toUpperCase();

    return actions;
  };

  actions.append = (str: string = '') => {
    formattedText = `${formattedText}${str}`;

    return {
      ...actions,
      percent: () => {
        const num = Number(formattedText);
        if (isNaN(num)) {
          return actions;
        }

        formattedText = Number(formattedText).toFixed(2);

        return actions.append('%');
      },
    };
  };

  actions.prepend = (str: string = '') => {
    formattedText = `${str}${formattedText}`;

    return { ...actions, currency: () => actions.prepend(CurrencySymbol) };
  };

  actions.getText = () => {
    return formattedText;
  };

  return { ...actions, formatNumber };
};

export const toUpperCase = (value: string) =>
  formatText(value)
    .toUpperCase()
    .getText();

export const toSentenceCase = (value: string) =>
  value
    .replace(/(\w)(\w*)/g, (_, firstChar, rest) => firstChar + rest.toLowerCase())
    .split('_')
    .join(' ');

export const formatPercentage = (value: number | string) => {
  const percentage = Number(value).toFixed(2);
  return `${percentage}%`;
};

export const formatToPattern = (value: string, pattern: string): string => {
  let i = 0;
  const v = value;

  return pattern.replace(/#/g, () => v[i++]);
};

export const formatTelephoneNumber = (value: string): string => {
  if (!value) return '';

  return formatToPattern(value, telephoneMask.map((part) => (part !== ' ' ? '#' : part)).join(''));
};

export const formatPostcode = (value: string): string => {
  if (!value) return '';

  return formatToPattern(
    value,
    postcodeMask(value)
      .map((part) => (part !== ' ' ? '#' : part))
      .join(''),
  );
};

export const formatSortCode = (value: string): string => {
  if (!value) return '';

  return formatToPattern(value, sortCodeMask.map((part) => (part !== '-' ? '#' : part)).join(''));
};

export const formatBoolean = (value: boolean) => (value ? 'Yes' : 'No');

export const formatFixRateTerm = (value: Nullable<number>) => {
  return value ? `${value} years` : 'Lifetime';
};

export const trimSpaces = (text: string) => {
  return text.replace(/\s/g, '');
};

export const numberWithCommas = (x: number) => x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
